import React, { useState } from 'react';
import { X, MessageCircle } from 'lucide-react';

const NUMBERS = [
  { label: 'Sales & Enquiries', display: '+6012-913 0786', wa: '60129130786' },
  { label: '24/7 Support', display: '+6019-373 5298', wa: '60193735298' }
];

const WaIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.004 3C8.83 3 3 8.83 3 16.004c0 2.29.6 4.53 1.74 6.5L3 29l6.66-1.7a12.94 12.94 0 0 0 6.34 1.64h.01C23.18 28.94 29 23.11 29 15.94 29 8.83 23.18 3 16.004 3zm0 23.7h-.01a10.7 10.7 0 0 1-5.45-1.5l-.39-.23-4.05 1.03 1.08-3.94-.25-.4a10.63 10.63 0 0 1-1.64-5.66c0-5.9 4.8-10.7 10.71-10.7 2.86 0 5.55 1.12 7.57 3.14a10.64 10.64 0 0 1 3.13 7.57c0 5.9-4.8 10.7-10.7 10.7zm5.87-8.02c-.32-.16-1.9-.94-2.2-1.05-.3-.11-.51-.16-.73.16-.21.32-.83 1.05-1.02 1.26-.19.21-.37.24-.7.08-.32-.16-1.36-.5-2.58-1.6a9.7 9.7 0 0 1-1.79-2.22c-.19-.32-.02-.5.14-.66.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.75-.99-2.4-.26-.62-.53-.54-.72-.55l-.62-.01c-.21 0-.56.08-.85.4-.3.32-1.12 1.1-1.12 2.68s1.15 3.11 1.31 3.32c.16.21 2.26 3.45 5.47 4.84.76.33 1.36.53 1.83.68.77.24 1.47.21 2.02.13.62-.09 1.9-.78 2.17-1.53.27-.75.27-1.4.19-1.53-.08-.13-.3-.21-.62-.37z" />
  </svg>
);

export default function WhatsAppBubble() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-3">
      {open && (
        <div data-testid="whatsapp-panel" className="w-72 rounded-2xl shadow-2xl border border-slate-200 overflow-hidden bg-white fade-up">
          <div className="bg-[#075E54] text-white p-4">
            <div className="flex items-center gap-3">
              <WaIcon size={24} />
              <div>
                <div className="font-bold text-sm">Fixed Group</div>
                <div className="text-xs text-white/80">Typically replies within minutes</div>
              </div>
            </div>
          </div>
          <div className="p-3 space-y-2 bg-[#ECE5DD]">
            {NUMBERS.map((n) => (
              <a
                key={n.wa}
                href={`https://wa.me/${n.wa}?text=${encodeURIComponent('Hello Fixed Group, I would like to enquire about your services.')}`}
                target="_blank"
                rel="noreferrer"
                data-testid={`whatsapp-chat-${n.wa}`}
                className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
              >
                <span className="w-10 h-10 rounded-full bg-[#25D366] text-white flex items-center justify-center flex-shrink-0"><WaIcon size={20} /></span>
                <span>
                  <span className="block text-xs text-slate-500">{n.label}</span>
                  <span className="block font-semibold text-slate-900 text-sm">{n.display}</span>
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-bubble"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl shadow-emerald-900/30 hover:scale-110 transition-transform"
      >
        {open ? <X size={26} /> : <WaIcon />}
      </button>
    </div>
  );
}
